module.exports = __webpack_public_path__ + "img/green_022.5777adde.png";